<template>
  <div>

    <!--[if IE]>
<style type="text/css">
.segmented-control > label:before { content:none;}
</style>
<![endif]-->
<!--头部搜索模块IE兼容性-->
<div class="ie7_ts"><em onclick="$('.ie7_ts').hide();">X</em>为了获得更好的用户体验，请使用火狐、谷歌、360浏览器极速模式或IE8及以上版本的浏览器</div>
<div class="xa_a">
    <div class="main">
        <span class="xa_ab">&nbsp;<a rel="nofollow" target="_blank" href="https://www.nxtt.org.cn/help/">常见问题</a><span style="margin-left:10px">&nbsp;<a rel="nofollow" target="_blank" href="https://www.nxtt.org.cn/about/">关于我们</a></span></span>
        <div class="xa_aa">
            <div class="f_l" id="nologin" >
                <div target="hiddenloginformiframe" id="loginfrm">
                    <span class="f_l">欢迎来到宁夏市场，请&nbsp;</span><a href="https://www.nxtt.org.cn/html/user/login.html?returl=https://qy.nxtt.org.cn/#/home/examination">登录</a>&nbsp;|&nbsp;<a href="https://www.nxtt.org.cn/html/user/reg.html">注册</a>
                </div>
            </div>
            
            <span class="f_l noshow" id="login">尊敬的 <span id="show_UserName" class="red"></span>， 欢迎光临！&nbsp; [<a href="https://my.nxtt.org.cn" target="_blank" rel="nofollow">会员中心</a>]&nbsp;&nbsp;[<span @click="logout" style="cursor: pointer">退出登录</span>]</span>
        </div>
    </div>
</div>
<div class="this_top">
    <div class="this_topa">
        <a href="https://www.nxtt.org.cn" class="logo"></a>
        <div class="this_topaa">
            <!--<form method="post" action="/search/tec/" id="formsearch">-->
            <!--<input type="hidden" id="CSRFToken" name="CSRFToken" value=""/>-->
            <input type="hidden" id="topurl" name="topurl" value="/search/tec/" />
            <div class="top_zka">
                <div class="hur1">
                    成果
                </div>
                <div class="this_topaaa">
                    <span class="on" @click="select_search('/search/tec/');">成果</span>
                    <span @click="select_search('/search/jsexpert/');">专家</span>
                    <span @click="select_search('/daxuenew/search/institude/');">院校</span>
                    <span @click="select_search('/search/xuqiu/');">需求</span>
                </div>
            </div>
            <div class="this_topaab">
                <input id="search-keyword" focucmsg="请输入关键字" type="text" onkeydown="if(event.keyCode==13){top_search_submit();}" name="q" value="请输入关键字" onfocus="if(this.value=='请输入关键字'){this.value='';this.style.color='#000000';}" onblur="if(this.value==''){this.value='请输入关键字';this.style.color='#c4c4c4';}" style="color: rgb(153, 153, 153);" />
                <a @click="top_search_submit()">搜索</a>
            </div>
            <!--</form>-->
        </div>
        <div class="this_topac">
           
            <span class="hur1 fr"><img src="https://image.nxtt.org.cn/market/yun/ningxia/www/images/this/wx.png" alt="" /><em>微信公众号</em></span>
        </div>
    </div>
    <div class="this_topb">
        <div class="main">
            <div class="topmenu">
                <span id="pindex" style="width: 60px;"><a  href="https://www.nxtt.org.cn">首页<i></i></a></span>
                <span class="topmenu_click" id="rcpt"><a target="_blank" href="https://www.nxtt.org.cn/meeting/" title="对接活动">对接活动<i></i></a></span>
                <span class="topmenu_hover" id="ptec"><a href="https:///www.nxtt.org.cn/kjzy/">科技资源<i></i></a></span>
                <!-- <span class="topmenu_click" id="fhzt"><a  target="_blank" href="https://www.nxcyzx.cn/">孵化载体<i></i></a></span> -->
                <span class="topmenu_click" id="psipo"><a href="https://www.nxtt.org.cn/zscq/">知识产权<i></i></a></span>                
                <span class="topmenu_click" id="pkjjr"><a href="https://www.nxtt.org.cn/kejijinrong/">科技金融<i></i></a></span>
                <span class="topmenu_click" id="pact"><a>创新活动<i></i></a></span>
                <span class="topmenu_click" id="pjiaoyi"><a>技术交易<i></i></a></span>
                <span class="topmenu_click" id="qyty" ><a href="https://qy.nxtt.org.cn/#/home/examination">企业体检<i></i></a></span> 
                
                
                <span class="topmenu_click" id="pzc" ><a target="_blank" href="https://jsq.nxinfo.org.cn/">科技政策</a></span>
                <span class="topmenu_click" id="pzx" ><a>新闻中心<i></i></a></span>
                <span class="topmenu_click" id="pgxzt" n><a href="https://hall.nxtt.org.cn">共享展厅<i></i></a></span>

                <span class="topmenu_click" id="ptongji"><a>数据统计<i></i></a></span>
                <span class="topmenu_click" id="pfz"><a>地市分站<i></i></a></span>
                <span class="topmenu_click" id="zltg"><a href="https://qy.nxtt.org.cn/#/home/patent-trust">专利托管<i></i></a></span>
                <div class="this_topbx" id="ptec_f">  
                    <div class="cur">
                        <a href="https://www.nxtt.org.cn/tec_strong/">科技成果</a>
                        <a href="https://www.nxtt.org.cn/cooperation/">东西部合作项目</a>
                        <a href="https://www.nxtt.org.cn/patent/">专利技术</a>
                        <a href="https://www.nxtt.org.cn/daxuenew/institude/">高校科研院所</a>
                        <a href="https://www.nxtt.org.cn/jsexpert/">专家人才</a>
                        <a href="https://www.nxtt.org.cn/xuqiu/">技术需求</a>
                        <!--<a href="/xuqiu/jmrh/">军民融合需求</a>-->
                        <a href="https://www.nxtt.org.cn/fuwu/fuwuman/">服务机构</a>
                        <a href="https://www.nxtt.org.cn/guoyoutec/" style="overflow:hidden;" title="国有科技成果挂牌公示">国有科技成果挂牌公示</a>
                        <a href="https://www.nxtt.org.cn/xuqiu/">科研众包</a>
                        <a href="https://www.nxtt.org.cn/cxy/home/">高校图谱</a>
                    </div>
                </div>
                <div class="this_topbx" id="pact_f">
                    <div class="cur">
                        <a href="https://www.nxtt.org.cn/act/">在线展会</a>
                        <a href="https://hall.nxtt.org.cn/actIndex/actList/1">线下活动</a>
                        <a href="https://hall.nxtt.org.cn/live/index">视频直播</a>
                    </div>
                </div>
                <div class="this_topbx" id="pjiaoyi_f">
                    <div class="cur">
                        <a href="https://www.nxtt.org.cn/jspg/">技术评估</a>
                        <a href="https://www.nxtt.org.cn/jiaoyi/">技术交易</a>
                        <a href="https://www.nxtt.org.cn/guakao/index_jszj/">技术经纪人</a>
                        <a href="https://www.nxtt.org.cn/guakao/index_qykjzy/">企业科技专员</a>
                        <a href="https://www.nxtt.org.cn/guakao/index_yskjzy/">院所科技专员</a>
                    </div>
                </div>
                <div class="this_topbx" id="pzc_f2">
                    <div class="cur">
                        <a href="https://www.nxtt.org.cn/zc/">本地政策</a>
                        <a href="https://www.nxtt.org.cn/zc_402/">国内政策</a>
                        <a href="https://www.nxtt.org.cn/zc/zxzc.html">政策解读</a>
                        <a href="https://www.nxtt.org.cn/zc/shenbao.aspx">项目申报</a>
                        <a id="pcompass" href="/compass/site/">政策指南针<em>&gt;</em>&nbsp;&nbsp;&nbsp;</a>
                    </div>
                    <div class="this_topbx_right" id="pcompass_fr">
                        <div class="cur">
                            <a href="https://www.nxtt.org.cn/compass/site/">宣传页</a>
                            <a href="https://www.nxtt.org.cn/compass/companynew/matchingchannel">政策速配</a>
                            <a href="https://www.nxtt.org.cn/compass/policynew/list">政策解读</a>
                            <a href="https://www.nxtt.org.cn/compass/statistic/detail.aspx">政策统计</a>
                        </div>
                    </div>
                </div>
                
                <div class="this_topbx" id="pzx_f">
                    <div class="cur">
                        <a href="https://www.nxtt.org.cn/gonggao/">通知公告</a>
                        <a href="https://www.nxtt.org.cn/dongtai/">服务动态</a>
                        <a href="https://www.nxtt.org.cn/zixun/">科技资讯</a>
                        <a href="https://www.nxtt.org.cn/shichang/">市场动态</a>
                    </div>
                </div>
                <div class="this_topbx" id="ptongji_f">
                    <div class="cur">
                        <a href="https://www.nxtt.org.cn/tongji/">平台服务统计</a>
                        <a href="https://www.nxtt.org.cn/hall/viewboard/pc.aspx">平台服务实况</a>
                    </div>
                </div>
                <div class="this_topbx" id="pfz_f">
                    <div class="cur">
                        <a target="_blank" href="https://www.nxtt.org.cn/fenzhan/fz_yc.aspx">银川市分站</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/fenzhan/fz_zw.aspx">中卫市分站</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/fenzhan/fz_gy.aspx">固原市分站</a>
                        <a target="_blank" href="https://wzstrm.nxtt.org.cn/">吴忠市分站</a>
                        <a target="_blank" href="https://szstrm.nxtt.org.cn/">石嘴山分站</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/fenzhan/fz_yc_gx.aspx">银川国家级高新技术开发区分站</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/fenzhan/fz_yc_kf.aspx">银川国家级经济技术开发区分站</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/fenzhan/fz_szs_gx.aspx">石嘴山国家级高新技术开发区分站</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/fenzhan/fz_szs_kf.aspx">石嘴山国家级经济技术开发区分站</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/fenzhan/fz_zw_gx.aspx">中卫工业园区分站</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/fenzhan/fz_nd.aspx">宁东能源化工基地分站</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/fenzhan/fz_yhcx.aspx">沿黄科技创新改革试验区分站</a>
                    </div>
                </div>

                <div class="this_topbx" id="rcpt_f">
                    <div class="cur">
                        <a href="https://www.nxtt.org.cn/meeting/">交流大会</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/meeting/tec/list.aspx">找成果</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/meeting/rencai/list.aspx">找人才</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/meeting/xuqiu/list.aspx">找需求</a>
                        <a target="_blank" href="https://www.nxtt.org.cn/meeting/hezuo/list.aspx">找合作</a>
                    </div>
                       
                </div>
                <div class="this_topbx" id="fhzt_f">
                    <div class="cur">
                        <a target="_blank" href="https://www.nxcyzx.cn/space">孵化地图</a>
                        <a target="_blank" href="https://www.nxcyzx.cn/tutor">导师服务</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="clear:both;"></div>
</div>


  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import {storePersistKey} from "@/plugins/tools/Constant";
  import {clearLocalToken} from "@/plugins/tools/storage";
export default {
    name: "indexHeader",
    mounted() {
      this. InitMenu();
      setTimeout(() => {
        if(this.compellation != ''){
            $("#login").show();$("#nologin").hide();$("#show_UserName").html(this.compellation)
        }  

      }, 1000);
    },
    computed: {
      ...mapGetters({
        compellation: 'userStore/compellation'
      })
    },
    data(){
        return {
            dahuiUrl:"",
        }
    },
    methods: {
     logout(){
        clearLocalToken()
        window.location.href = "https://www.nxtt.org.cn/"
     },   
     InitMenu() {

        $.ajax({
            type: "get",
            dataType:"jsonp",
            url: "https://www.nxtt.org.cn/ajax/dahui.aspx",
            success: function (json) {

                if (json.code == 1) {
                    this.dahuiUrl = json.data;
                }
            }
        })

        function dahuibaoming() {

            if (!this.dahuiUrl) {
                layer.alert("提示当前非大会报名期限，无法报名");
            }
            else {
                window.open(this.dahuiUrl);
            }

        }


        $(".topmenu span.topmenu_click").mouseover(function() {
               var zhi1=( $(this).attr("id") );
                var zhi2=('#' + zhi1 + '_f');
                $('.this_topbx').removeClass('this_topbx_h');
                $('.topmenu span').removeClass('ho');
                $(zhi2).addClass('this_topbx_h');
                $(this).addClass('ho');
                //获取zhi1的left值，并赋值给zhi2
                var left = $(this).position().left;
                $(zhi2).css('left', left);
        });
        $(".topmenu span.topmenu_hover").hover(function() {
            var b = ($(this).attr("id"));
            var a = ("#" + b + "_f");
            $(".this_topbx").removeClass("this_topbx_h");
            $(".topmenu span").removeClass("ho");
            $(a).addClass("this_topbx_h");
            $(this).addClass("ho")
        });
        $(".this_topbx").hover(function() {
            var b = ($(this).attr("id"));
            b = b.replace(/(.*)_f.*/, "$1");
            var a = ("#" + b);
            $(this).addClass("this_topbx_h");
            $(a).addClass("ho")
        }, function() {
            var b = ($(this).attr("id"));
            b = b.replace(/(.*)_f.*/, "$1");
            var a = ("#" + b);
            $(this).removeClass("this_topbx_h");
            $(a).removeClass("ho")
        });
        $(".this_topbx a").mouseover(function() {
            var b = ($(this).attr("id"));
            var a = ("#" + b + "_fr");
            $(a).show()
        });
        $(".this_topbx a").mouseout(function() {
            var b = ($(this).attr("id"));
            var a = ("#" + b + "_fr");
            $(a).hide()
        });
        $(".this_topbx_right").mouseover(function() {
            $(this).show()
        });
        $(".this_topbx_right").mouseout(function() {
            $(this).hide()
        });
        $(".this_topaaa span").click(function() {
            $(".this_topaaa span").removeClass("on");
            $(this).addClass("on")
        });
        $(function() {
            $(".this_topaaa span").click(function() {
                $(".this_topaaa").hide();
                $(".top_zka .hur1").empty();
                $(".top_zka .hur1").append($(this).text())
            });
            $(".top_zka .hur1").click(function() {
                $(".this_topaaa").toggle()
            })
        });
        $(function() {
            $(window).scroll(function() {
                if ($(window).scrollTop() >= 228) {
                    $(".hndba").addClass("hndba_f")
                } else {
                    $(".hndba").removeClass("hndba_f")
                }
            })
        });

        var b = false;
        var a = location.pathname;
        var c = location.href;
        

        if (c.indexOf("/home/patent-trust") > -1 ) {
            $("#zltg").addClass("on")
        } else if (c.indexOf("/home/examination") > -1 || c.indexOf("enterprise/") > -1) {
            $("#qyty").addClass("on")
        } else if (a == "/") {
            $(".topmenu > span:eq(0)").addClass("on")
        }
        if (a.indexOf("/gonggao/") > -1 || a.indexOf("/dongtai/") > -1) {
            a = "/zixun/"
        } else {
            if (a.indexOf("/tec_strong/") > -1 || a.indexOf("/xuqiu/") > -1 || a.indexOf("/daxue/institude/") > -1) {
                a = "/tec/"
            } else {
                if (a.indexOf("/platform_agency/") > -1) {
                    a = "/platform_agency/"
                } else {
                    if (a.indexOf("/jiaoyi/") > -1 || a.indexOf("/pinggu/") > -1) {
                        a = "/jiaoyi/"
                    } else {
                        if (a.indexOf("/guakao/") > -1) {
                            a = "/guakao/"
                        } else {
                            if (a.indexOf("/ptfwsk/") > -1) {
                                a = "/tongji/"
                            } else {
                                if (a.indexOf("/lsf/") > -1) {
                                    a = "/expert/"
                                } else {
                                    if (a.indexOf("/zc/") > -1 || a.indexOf("/zc_") > -1) {
                                        a = "/zc/"
                                    } else {
                                        if (a.indexOf("jszj") > -1) {
                                            a = "/guakao/index_jszj/"
                                        } else {
                                            if (a.indexOf("/fjcctt_huodong/") > -1) {
                                                a = "/act/"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
      }, 
      search_submit() {
        if ($('#search-keyword').val() == '请输入关键字' || $('#search-keyword').val() == '') { dialog1633.show('请输入关键字'); return false };
        return true;
      },
      select_search(s) {
        /*        $("#formsearch").attr("action", s);*/
        $("#topurl").val(s);
      },
      top_search_submit() {
        /*   if (search_submit()) { $('#formsearch').submit(); }*/
        var q = $("#search-keyword").val();
        if (q == '请输入关键字' || q == '') { dialog1633.show('请输入关键字'); return false }
        window.location.href = $("#topurl").val() + "?q=" + q;
     },
     showGenDuo(){
        if($(".this_topb").height()>80){
            $(".this_topb").css("height","45px");
            $(".this_topbx").css("top","55px");
            $(".topmenu span:gt(8)").hide()
        }else{
            $(".this_topb").css("height","90px");
            $(".this_topbx").css("top","100px");
            $(".topmenu span:gt(8)").show()
        }
        
    }
 
    }

  }


    function top_search_submit() {
        /*   if (search_submit()) { $('#formsearch').submit(); }*/
        var q = $("#search-keyword").val();
        if (q == '请输入关键字' || q == '') { dialog1633.show('请输入关键字'); return false }
        window.location.href = $("#topurl").val() + "?q=" + q;
    }
    $('#search-keyword').bind('keypress', function (event) {
        if (event.keyCode == "13") {
            if ($('#search-keyword').val() == '请输入关键字' || $('#search-keyword').val() == '') { dialog1633.show('请输入关键字'); return false }
            else { $('#formsearch').submit(); }
        }
    });

    $("#top_loginlink").attr("href", "/html/user/login.html?returl=" + encodeURIComponent(window.location.href));
    $("#top_reglink").attr("href", "/html/user/reg.html?returl=" + encodeURIComponent(window.location.href));
</script>

<style scoped lang="scss">

</style>
